module.exports = __webpack_public_path__ + "img/tab01.de715721.jpg";